import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Input, Modal, Typography } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { ConfirmExecutionModalStore } from '../../Stores/ConfirmExecutionModalStore'

const { Text } = Typography

interface ConfirmExecutionModalProps {
    assignmentUuid: string
    assignmentStatus: string
    open: boolean
    onClose: () => void
    onConfirmed: () => void
}

export const ConfirmExecutionModal = observer(
    ({ assignmentUuid, assignmentStatus, open, onClose, onConfirmed }: ConfirmExecutionModalProps) => {
        const [store] = useState(() => new ConfirmExecutionModalStore())
        const { showSuccess, showError } = useNotification()

        const commentRequired = assignmentStatus !== 'completed_by_driver'

        const handleConfirm = async () => {
            const ok = await store.confirm(assignmentUuid, assignmentStatus, { success: showSuccess, error: showError })
            if (ok) {
                onConfirmed()
                onClose()
            }
        }

        return (
            <Modal
                open={open}
                title="Підтвердити виконання завдання"
                onCancel={onClose}
                footer={[
                    <Button key="cancel" onClick={onClose}>
                        Скасувати
                    </Button>,
                    <Button
                        key="confirm"
                        type="primary"
                        loading={store.loading}
                        disabled={commentRequired && !store.comment.trim()}
                        onClick={handleConfirm}
                    >
                        Підтвердити
                    </Button>,
                ]}
            >
                {commentRequired && (
                    <div style={{ marginBottom: 8 }}>
                        <Text type="warning">Завдання не завершено водієм — коментар диспетчера обов'язковий.</Text>
                    </div>
                )}
                <Input.TextArea
                    rows={3}
                    placeholder={commentRequired ? 'Коментар диспетчера *' : "Коментар диспетчера (необов'язково)"}
                    value={store.comment}
                    onChange={(e) => store.setComment(e.target.value)}
                />
            </Modal>
        )
    }
)
